import { useContext, useEffect, useState } from "react";
import { Button, Col, Modal, Row, Spinner, Table } from "react-bootstrap";
import BlockContainer from "../components/BlockContainer";
import { SelectForm, TextForm } from "../components/FormItem";
import { AuthContext } from "../contexts/AuthContext";
import { getFileURL } from "../databases/files";
import { QueryAllMaolam, UpdateMaolamUser } from "../databases/maolam";
import { MAOLAM_APPROVED, MAOLAM_NONE, MAOLAM_REJECTED, MAOLAM_WAITING, TITLE } from "../databases/spName";

const MaolamTitles = {
    index : "#",
    dateString : 'เวลาที่ลงชื่อ',
    nameEN : "ชื่อ-นามสกุล",
    telephone : 'หมายเลขโทรศัพท์',
    lineID : 'ไอดีไลน์',
}

const PageMaolamApprove = () => {

    const [mWaiting, setMWaiting] = useState({})
    const [mRejected, setMRejected] = useState({})
    const [mApproved, setMApproved] = useState({})

    const [cuid, setCuid] = useState(null)
    const [currentURL, setCurrentURL] = useState({url : '', type : '', updated : '', onLoading : false});
    const [onLoading, setOnLoading] = useState(false)

    const [aModal, setAModal] = useState(false)
    const [rModal, setRModal] = useState(false)
    const [dModal, setDModal] = useState(false)

    const [aData, setAData] = useState({ note : '', round : 0 })
    const [rData, setRData] = useState({ reason : '' })

    const { owndata, userRole } = useContext(AuthContext)
    const { nickName } = owndata

    useEffect(() => {
        const q = async () => {
            if (userRole >= 2) {
                const { waiting, rejected, approved } = await QueryAllMaolam()
                setMWaiting(waiting)
                setMRejected(rejected)
                setMApproved(approved)
            }
        }
        q();
    }, [userRole])

    useEffect(() => {
        return () => {
            setMWaiting({})
            setMRejected({})
            setMApproved({})
            setAData({ note : '', round : 0 })
            setRData({ reason : '' })
            setCuid(null)
            setOnLoading(false)
            setCurrentURL({url : '', type : '', field : '', updated : '', onLoading : false});
        }
    }, [])

    const TableHead = (type) => {
        switch (type) {
            case MAOLAM_NONE: default:
                return (
                    <thead />
                )
            case MAOLAM_WAITING:
                return (
                    <thead>
                        <tr>
                            {Object.values(MaolamTitles).map((v, i) => <th key={i}>{v}</th>)}
                            <th colSpan={2}>การตอบรับ</th>
                        </tr>
                    </thead>
                )
            case MAOLAM_REJECTED:
                return (
                    <thead>
                        <tr>
                            {Object.values(MaolamTitles).map((v, i) => <th key={i}>{v}</th>)}
                            <th>เหตุผล</th>
                            <th>ผู้ตรวจสอบ</th>
                        </tr>
                    </thead>
                )
            case MAOLAM_APPROVED:
                return (
                    <thead>
                        <tr>
                            {Object.values(MaolamTitles).map((v, i) => <th key={i}>{v}</th>)}
                            <th>เที่ยวบิน</th>
                            <th>หมายเหตุ</th>
                            <th>ผู้ตรวจสอบ</th>
                        </tr>
                    </thead>
                )
        }
    }

    const TableBody = (type, data) => {
        const EM = (u) => {
            switch (type) {
                case MAOLAM_NONE: default:
                    return <></>
                case MAOLAM_WAITING:
                    return (
                        <>
                            <td><Button onClick={() => {setAModal(true); setCuid(u.uid)}} variant="primary">ยอมรับ</Button></td>
                            <td><Button onClick={() => {setRModal(true); setCuid(u.uid)}} variant="danger">ปฏิเสธ</Button></td>
                        </>
                    )
                case MAOLAM_REJECTED:
                    return (<>
                        <td>{u.reason}</td>
                        <td>{u.approver}</td>
                    </>)
                case MAOLAM_APPROVED:
                    return (<>
                        <td>{u.round}</td>
                        <td>{u.approver}</td>
                        <td>{u.note}</td>
                    </>)
            }
        }
        return (
            <tbody>
                {[...Object.keys(data)].map((uid, index) => (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{data[uid].dateString}</td>
                        <td><div className="link-style" onClick={() => onDataViewClick(uid)}>{currentURL.onLoading ? <Spinner animation="border" size='sm'/> : data[uid].nameEN}</div></td>
                        <td>{data[uid].telephone}</td>
                        <td>{data[uid].lineID}</td>
                        {EM(data[uid])}
                    </tr>
                ))}
            </tbody>
        )
    }

    const onRejectClick = async () => {
        try {
            setOnLoading(true)
            await UpdateMaolamUser(cuid, { ...rData, status : MAOLAM_REJECTED, approver : nickName })
            setRData({ reason : '' })
            alert('ทำการปฏิเสธแล้ว')
            setRModal(false)
            const { waiting, rejected, approved } = await QueryAllMaolam()
            setMWaiting(waiting)
            setMRejected(rejected)
            setMApproved(approved)
        }
        catch (e) {
            console.log(e)
        }
        finally {
            setOnLoading(false)
        }
    }

    const onApproveClick = async () => {
        try {
            setOnLoading(true)
            await UpdateMaolamUser(cuid, { approver : nickName, note : aData.note, status : MAOLAM_APPROVED })
            setAData({ note : '', round : 0 })
            alert('ทำการยอมรับแล้ว')
            setAModal(false)
            const { waiting, rejected, approved } = await QueryAllMaolam()
            setMWaiting(waiting)
            setMRejected(rejected)
            setMApproved(approved)
        }
        catch (e) {
            console.log(e)
        }
        finally {
            setOnLoading(false)
        }
    }

    const onDataViewClick = async (uid) => {
        try {
            setCurrentURL(c => ({...c, onLoading : true }))
            setCuid(uid)
            const { url, type, size, updated } = await getFileURL(`${uid}/เอกสารอื่น ๆ`).catch(() => setCurrentURL(c => ({...c, onLoading : false })))
            setCurrentURL({ url, type, size, updated, onLoading : false})
            setDModal(true); 
        }
        catch (e) {
            console.log(e)
        }
        finally {
            setCurrentURL(c => ({...c, onLoading : false }))
        }
        
    }

    return (
        <div>
            <div className="bold">คนที่ลงทะเบียนเที่ยวบินเหมาลำ</div>
            <br />
            <BlockContainer>
                <div className="bold">รอดำเนินการ</div>
                <Table responsive striped bordered hover>
                    {TableHead(MAOLAM_WAITING)}
                    {TableBody(MAOLAM_WAITING, mWaiting)}
                </Table>
            </BlockContainer>
            <br />
            <BlockContainer>
                <div className="bold">ยอมรับการลงทะเบียนแล้ว</div>
                <Table responsive striped bordered hover>
                    {TableHead(MAOLAM_APPROVED)}
                    {TableBody(MAOLAM_APPROVED, mApproved)}
                </Table>
            </BlockContainer>
            <br />
            <BlockContainer>
                <div className="bold">ปฏิเสธการลงทะเบียนแล้ว</div>
                <Table responsive striped bordered hover>
                    {TableHead(MAOLAM_REJECTED)}
                    {TableBody(MAOLAM_REJECTED, mRejected)}
                </Table>
            </BlockContainer>
            <br />
            <Modal show={aModal} size='sm' onHide={() => {setAModal(false); setCuid(null)}} onShow={() => setAData({ note : '', round : 0 })}>
                <Modal.Body>
                    <SelectForm title='เที่ยวบิน' value={aData.round} options={TITLE.round.options} onChange={e => setAData(d => ({...d, round : parseInt(e.target.value)}))} />
                    <TextForm title='หมายเหตุ' value={aData.note} onChange={e => setAData(d => ({...d, note : e.target.value }))} />
                    <div className="bold">ผู้ตรวจสอบ : {nickName || 'ใส่ชื่อเล่นด้วยจ้า'}</div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" disabled={onLoading} onClick={() => setAModal(false)}>ยกเลิก</Button>
                    <Button variant="primary" disabled={true} onClick={onApproveClick}>ยอมรับคำขอ</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={rModal} size='sm' onHide={() => {setRModal(false); setCuid(null)}} onShow={() => setRData({ reason : ''})}>
                <Modal.Body>
                    <TextForm title='เหตุผล' value={rData.reason} onChange={e => setRData(d => ({...d, reason : e.target.value }))} />
                    <div className="bold">ผู้ตรวจสอบ : {nickName || 'ใส่ชื่อเล่นด้วยจ้า'}</div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" disabled={onLoading} onClick={() => setRModal(false)}>ยกเลิก</Button>
                    <Button variant="primary" disabled={onLoading} onClick={onRejectClick}>ปฏิเสธคำขอ</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={dModal} size='xl' onHide={() => {setDModal(false); setCuid(null)}}>
                <Modal.Body>
                    <Row>
                        <Col xl='3' lg='4' md='12'>
                            {['nameEN', 'passport', 'school', 'telephone', 'lineID'].map((field, index) => (
                                <div key={index}>
                                    <div className="bold">{TITLE[field].TH}</div>
                                    <div>{mWaiting[cuid] ? mWaiting[cuid][field] : ''}</div>
                                    <hr />
                                </div>
                            ))}
                        </Col>
                        <Col>
                            {currentURL.url && currentURL.type === 'application/pdf' ? 
                            <object data={currentURL.url} type="application/pdf" width='90%' height='90%' style={{minHeight : '500px'}} >
                                ขออภัย บราวเซอร์นี้ไม่สามารถแสดงผล pdf ได้
                            </object> : <> ขออภัย ไม่ใช่ไฟล์ pdf </>}
                        </Col>
                    </Row>
                    
                        

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => setDModal(false)}>ปิด</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default PageMaolamApprove;